import {getCurrentUser} from "./requests";
import Cookies from "js-cookie";
import {getDateANumberOfDaysFromNow} from "../utils/dateManipulation";

const QIDIGO_TOKEN = 'qidigo-auth-token';
const NUMBER_OF_DAYS_TO_REMEMBER_COOKIE = 1;

export const isLoggedIn = async (): Promise<boolean> => {
    const user = await getCurrentUser();
    return !!user && !!user.id;
};

export const getToken = (): string | null => {
    try {
        const token = localStorage.getItem(QIDIGO_TOKEN)
        if (token) {
            const encoded = token.split(".")[1].replace("-", "+").replace("_", "/")
            const { exp } = JSON.parse(window.atob(encoded))
            if (exp < Math.floor(Date.now() / 1000)) {
                setToken(null)
                return null
            }
        }

        return token;
    } catch {
        setToken(null)
        return null
    }
}

export const setToken = (token: string | null): void => {
    if (token) {
        try {
            localStorage.setItem(QIDIGO_TOKEN, token)
        } catch (e) {
            console.error(e)
        }

        //Will connect the user to qidigo.com
        Cookies.set(QIDIGO_TOKEN, token, {
            path: '/',
            expires: getDateANumberOfDaysFromNow(NUMBER_OF_DAYS_TO_REMEMBER_COOKIE),
            sameSite: 'none',
            secure: process.env.NODE_ENV !== "development"
        });
    }
    else {
        try {
            localStorage.removeItem(QIDIGO_TOKEN)
        } catch (e) {
            console.error(e)
        }
        Cookies.remove(QIDIGO_TOKEN)
    }
}
